module.exports = __webpack_public_path__ + "media/src/images/logos/partners/iflytek-93547293a7a2c3de1972cd7679daa9f8.png";